<script setup lang="ts">
import {Info} from "@/types";
import {getCourseType} from "@/utils/common.ts";
import {computed} from "vue";
import {dayjs} from "element-plus";

const props =defineProps<{
  info: Info | undefined
}>()

const emit = defineEmits(["onPublishNotice", "onEditInfo", "previewPublish", "showStudentList", "getSecretInfo"])

const onPublishNotice = () => {
  emit("onPublishNotice");
}

const onEditInfo = () => {
  emit("onEditInfo")
}

const previewPublish = () => {
  emit("previewPublish")
}

const showStudentList = () => {
  emit("showStudentList")
}

const getSecretInfo = () => {
  emit("getSecretInfo")
}

const upDownTime = computed(() => {
  if (props.info?.putaway_time && props.info.down_time) {
    let info = `${dayjs((props.info.putaway_time) * 1000).format("YYYY年MM月DD日 HH:mm")}上架 ~ ${dayjs((props.info.down_time) * 1000).format("YYYY年MM月DD日 HH:mm")}下架`
    let valid = ""
    if (props.info.status === 1) {
      valid = ` (有效期：${props.info.buy_valid_date})`
    }
    return info + valid
  }
  return ""
})
</script>

<template>
  <div class="bg-white py-1.5rem pl-2rem pr-2.25rem flex items-start rounded-md shadow-md" v-if="info">
    <el-image class="w-23.4375rem h-13.1875rem mr-1.75rem" :src="info.thumb_image"/>
    <div class="mr-1rem flex-1">
      <div class="text-#161616 text-1.25em font-bold">
        {{ info.title }}
      </div>
      <div class="mt-.75rem flex items-center gap-.75rem">
        <el-tag round effect="light">
          {{ getCourseType(info.type) }}
        </el-tag>
        <el-tag round effect="light">
          {{ info.cate_name }}
        </el-tag>
        <el-tag round effect="light">
          {{ info.two_cate_name }}
        </el-tag>
      </div>
      <div class="text-#939393 text-.875em mt-.75rem">
        <span>
          {{ `简介：` }}
        </span>
        <span>
          {{ info.short_detail }}
        </span>
      </div>
      <div class="text-#939393 text-.875em mt-.75rem">
        <span>
          {{ `容量：` }}
        </span>
        <span>
          <template v-if="info.type === 1 || info.type === 2">
            {{ `共${info.total_section}讲` }}
          </template>
          <template v-if="info.type === 1">
            {{ `，每讲${info.duration}分钟` }}
          </template>
           <template v-if="info.type === 3 || info.type === 4">
            {{ `共${info.total_section}门课` }}
          </template>
        </span>
      </div>
      <div class="text-#939393 text-.875em mt-.75rem" v-if="info.type === 1">
        <span>
          {{ `时间：` }}
        </span>
        <span>
          {{ info.sign_time }}
        </span>
      </div>
      <div class="text-#939393 text-.875em mt-.75rem" v-if="info.type !== 4">
        <span>
          {{ `学费：` }}
        </span>
        <span class="text-#FF892A">
          {{ info.price }}
        </span>
      </div>
      <div class="text-#939393 text-.875em mt-.75rem" v-if="info.status === 1">
        <span>
          {{ `在架：` }}
        </span>
        <span>
          {{ upDownTime }}
        </span>
      </div>
    </div>
    <div class="flex flex-col items-end my-auto gap-.75rem">
      <el-button
          type="primary"
          plain class="w-10rem h-2.5rem"
          v-if="info.type === 1 || info.type === 2"
          @click="onPublishNotice">发布公告
      </el-button>
      <el-button
          type="primary" plain class="w-10rem h-2.5rem"
          @click="onEditInfo">编辑信息
      </el-button>
      <el-button
          type="primary" class="w-10rem h-2.5rem"
          @click="previewPublish"
          v-if="info.status === 2">预览并发布
      </el-button>
      <el-button
          type="primary" class="w-10rem h-2.5rem"
          @click="getSecretInfo"
          v-if="info.status === 1 && info.is_secret === 1">分享口令
      </el-button>
      <el-button
          type="primary" class="w-10rem h-2.5rem"
          @click="showStudentList"
          v-if="info.status === 1 && (info.type !== 4)">学员列表
      </el-button>
    </div>
  </div>
</template>

<style scoped>
</style>